"use client";

import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import DateCell from "@core/ui/date-cell";
import { Text } from "rizzui";
import TableRowActionGroup from "../../../table-row-action-group";
import { Withdrawal } from "packages/app/src/types";
import { getStatusBadge } from "@core/components/table-utils/get-status-badge";

// 2. (Optional) reuse the safe currency formatter from above
function formatCurrency(amount: number, code = "NGN") {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })} ${code}`;
  }
}

const columnHelper = createColumnHelper<Withdrawal>();

export const withdrawalColumns = [
  columnHelper.display({
    id: "actions",
    size: 80,
    header: "Actions",
    cell: ({
      row,
      table: {
        options: { meta },
      },
    }) => (
      <TableRowActionGroup
        onDelete={() => meta?.handleDeleteRow?.(row.original)}
      />
    ),
  }),
  columnHelper.accessor("id", {
    id: "id",
    size: 200,
    header: "Withdrawal ID",
    cell: ({ row }) => <Text className="font-medium">{row.original.id}</Text>,
  }),

  //   columnHelper.accessor("referenceId", {
  //     id: "referenceId",
  //     size: 250,
  //     header: "Reference",
  //     cell: ({ row }) => <Text>{row.original.referenceId}</Text>,
  //   }),

  columnHelper.accessor("amount", {
    id: "amount",
    size: 150,
    header: "Amount",
    cell: ({ row }) => (
      <Text className="font-semibold">
        {formatCurrency(row.original.amount, "NGN")}
      </Text>
    ),
  }),

  columnHelper.accessor("fee", {
    id: "fee",
    size: 120,
    header: "Fee",
    cell: ({ row }) => <Text>{formatCurrency(row.original.fee, "NGN")}</Text>,
  }),

  columnHelper.accessor("amountAfterFee", {
    id: "amountAfterFee",
    size: 180,
    header: "Net Amount",
    cell: ({ row }) => (
      <Text className="font-semibold">
        {formatCurrency(row.original.amountAfterFee, "NGN")}
      </Text>
    ),
  }),

  columnHelper.accessor("status", {
    header: "Status",
    size: 120,
    cell: ({ row }) => {
      const s = row.original.status;
      return s ? getStatusBadge(s) : <Text>-</Text>;
    },
  }),

  columnHelper.accessor("campaign", {
    id: "campaign",
    size: 200,
    header: "Campaign ID",
    cell: ({ row }) => <Text>{row.original.campaign}</Text>,
  }),

  columnHelper.accessor("bankDetails", {
    id: "bankDetails",
    size: 300,
    header: "Bank Details",
    cell: ({ row }) => {
      const b = row.original.bankDetails;
      return (
        <div className="space-y-1">
          <Text className="font-medium">{b.account_name}</Text>
          <Text className="text-sm">Acct No: {b.account_number}</Text>
          {/* <Text className="text-sm">Bank Code: {b.bank_code}</Text> */}
        </div>
      );
    },
  }),

  columnHelper.accessor("createdAt", {
    id: "createdAt",
    size: 180,
    header: "Requested On",
    cell: ({ row }) => <DateCell date={new Date(row.original.createdAt)} />,
  }),
];
